import { constants, types } from "../definitions";

export const getRealm = (hostname: string): types.Realm | null => {
  // TODO: second clause is to allow this helper to work prior to us having help.local.twilio.com as a host for local
  const hasMatch =
    hostname.match(/help\.(?<realm>dev|stage|local)\.twilio/) ||
    hostname.match(/(?<realm>local)host/) ||
    hostname.match(/(?<realm>dev|stage|local)\.twilio\.com$/);

  if (hasMatch && hasMatch.groups) {
    return hasMatch.groups.realm as types.Realm;
  }

  return null;
};

export const getTwilioHost = (hostname: types.Hostname): types.Hostname => {
  return constants.realmToHost[getRealm(hostname) || types.Realm.prod];
};

export const getTwilioProtocol = (hostname: types.Hostname): string => {
  return getTwilioHost(hostname) === "www.local.twilio.com"
    ? "http://"
    : "https://";
};

export const getConfig = (): types.ConfigValues => {
  const realm =
    getRealm(window.location.hostname as types.Hostname) || types.Realm.prod;

  const baseConfig = {
    chatWidgetSourceFile: "one-support-center-widget.js",
    incidentStatusPage: {
      [types.Org.twilio]: "https://status.twilio.com",
      [types.Org.sendGrid]: "https://status.sendgrid.com",
      [types.Org.segment]: "https://status.segment.com",
      [types.Org.zipwhip]: "https://app-status.zipwhip.com",
    },
    searchIndex: types.SearchIndexEnum.twilio,
    realm,
  };

  const config: types.Config = {
    [types.Realm.prod]: {
      ...baseConfig,
      chatWidgetSource: `https://assets.twilio.com/public_assets/support/${constants.chatWidgetVersion}/${baseConfig.chatWidgetSourceFile}`,
      csrfEndpoint: "https://www.twilio.com/api/csrf",
      hostName: "https://help.twilio.com",
      currentAccountCookieDomain: ".www.twilio.com",
      priorityLevelFieldId: "20551717",
      segmentWriteKey: "kAjvDMcGCgzvdvyUuc6EBC8Geclvum1x",
      splitAuthorizationKey: "eo858j4suqc1d9l34ieet2e71bh1cjde52ng",
      supportApiEndpoint: "https://www.twilio.com/console/osc/api",
      recaptchaSiteKey: "6Ld0t6glAAAAAIiwPaRRFL0VeM4IKprsXeb8GrLj",
      consoleEndpoint: "https://www.twilio.com/console",
      webEndpoint: types.Hostname.prod,
    },
    [types.Realm.stage]: {
      ...baseConfig,
      chatWidgetSource: `https://assets.twilio.com/public_assets/support/${constants.chatWidgetVersion}/${baseConfig.chatWidgetSourceFile}`,
      csrfEndpoint: "https://www.stage.twilio.com/api/csrf",
      hostName: " https://help.stage.twilio.com",
      currentAccountCookieDomain: ".www.stage.twilio.com",
      priorityLevelFieldId: "28245318",
      segmentWriteKey: "1rooaFSZEzDxdB9kpJegqDGfRoqD1B8Q",
      splitAuthorizationKey: "1s2p8gdot9t60t768ktoi616e4cocb6ebmj5",
      supportApiEndpoint: "https://www.stage.twilio.com/console/osc/api",
      recaptchaSiteKey: "6Ldxt6glAAAAAOygpaQ3md2sWNMekNSliGFTvNnS",
      consoleEndpoint: "https://www.stage.twilio.com/console",
      webEndpoint: types.Hostname.stage,
    },
    [types.Realm.dev]: {
      ...baseConfig,
      chatWidgetSource: `https://assets.twilio.com/public_assets/support/${constants.chatWidgetVersion}/${baseConfig.chatWidgetSourceFile}`,
      csrfEndpoint: "https://www.dev.twilio.com/api/csrf",
      hostName: " https://help.dev.twilio.com",
      currentAccountCookieDomain: ".www.dev.twilio.com",
      priorityLevelFieldId: "28245318",
      segmentWriteKey: "8XclIx4jSPDyeVxTdeLqnnk78hTusRIP",
      splitAuthorizationKey: "1s2p8gdot9t60t768ktoi616e4cocb6ebmj5",
      supportApiEndpoint: "https://www.dev.twilio.com/console/osc/api",
      recaptchaSiteKey: "6Ldvt6glAAAAAA-fUuXNdaERxxUUrwhyTNgUxwQP",
      consoleEndpoint: "https://www.dev.twilio.com/console",
      webEndpoint: types.Hostname.dev,
    },
    [types.Realm.local]: {
      ...baseConfig,
      // Use dev source unless testing locally against support-ui
      // chatWidgetSource: `http://localhost:17981/${baseConfig.chatWidgetSourceFile}`,
      chatWidgetSource: `https://assets.twilio.com/public_assets/support/${constants.chatWidgetVersion}/${baseConfig.chatWidgetSourceFile}`,
      csrfEndpoint: "http://www.local.twilio.com/api/csrf",
      hostName: "http://help.local.twilio.com",
      currentAccountCookieDomain: ".www.local.twilio.com",
      priorityLevelFieldId: "28245318",
      segmentWriteKey: "8XclIx4jSPDyeVxTdeLqnnk78hTusRIP",
      splitAuthorizationKey: "1s2p8gdot9t60t768ktoi616e4cocb6ebmj5",
      recaptchaSiteKey: "6Ldvt6glAAAAAA-fUuXNdaERxxUUrwhyTNgUxwQP",
      supportApiEndpoint: "http://www.local.twilio.com/console/osc/api",
      consoleEndpoint: "http://www.local.twilio.com/console",
      webEndpoint: types.Hostname.local,
    },
  };

  return config[realm] || config[types.Realm.local];
};
